var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0"},[_c('h2',{staticClass:"pa-0 ma-0"},[_vm._v(_vm._s(_vm.title))]),_c('v-divider',{staticClass:"pa-0 ma-0 mb-2",attrs:{"color":"white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }